/**
 *
 * @param {laterTime}  过去的时间
 * @returns 计算过去到现在的年份方便select选择
 */
export function getlaterYear(laterTime = '2019') {
  let yearList = []
  let laterDate = new Date(laterTime)
  let lateYear = laterDate.getFullYear()
  let date = new Date()
  let y = date.getFullYear()
  for (let i = lateYear; i <= y; i++) {
    let obj = {
      label: '',
      id: -1,
      name: '',
    }
    obj.label = i
    obj.id = i
    obj.name = i
    yearList.push(obj)
  }
  yearList.unshift({
    label: -1,
    id: -1,
    name: '不限',
  })
  return yearList
}

export function getCurrenMothFisrtEndDay(datetime) {
  const date = datetime ? new Date(datetime) : new Date()
  let obj = {
    firstDay: '',
    lastDay: '',
  }
  let arr = []
  date.setDate(1) // 将当前时间的日期设置成第一天
  let year = date.getFullYear() // 得到当前年份
  let month = date.getMonth() + 1 // 得到当前月份（0-11月份，+1是当前月份）
  month = month > 10 ? month : '0' + month // 补零
  arr.push(year)
  arr.push(month) // 得到当前月份
  let day = date.getDate() // 得到当前天数，实际是本月第一天，因为前面setDate(1) 设置过了
  arr.push(day)
  obj.firstDay = arr.join('/')
  //第一种计算最后天
  // let nextMonthFirthDay = new Date(year, month, 1) // 下个月的第一天
  // let oneDay = 1000 * 60 * 60 * 24 // 一天的时间毫秒数
  // let endDay = new Date(nextMonthFirthDay - oneDay)
  // let lastDay = endDay.getDate() // 本月最后一天
  //第二种计算最后天
  let nextMonthFirthDay = new Date(year, month, 0) // 下个月的第一天
  let lastDay = nextMonthFirthDay.getDate() // 本月最后一天
  arr.pop()
  arr.push(lastDay)
  obj.lastDay = arr.join('/')
  return obj
}

export function checkPhone(phoneNumber) {
  let myreg = /^1[3-9]\d{9}$/
  if (!myreg.test(phoneNumber)) {
    return false
  } else {
    return true
  }
}



// WEBPACK FOOTER //
// ./src/comm/utils/DateTime.js